import { motion } from "framer-motion";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { useIsMobile } from "@/hooks/use-mobile";
import SectionGlow from "./SectionGlow";
import { ease, duration } from "@/lib/motion";
const faqs = [
  { q: "How much does a website cost?", a: "Two options: a one-time project fee, or a lower upfront cost with a monthly retainer for ongoing support. We walk you through both on your discovery call." },
  { q: "How long does it take to build a website?", a: "Most projects launch in 7 days. We work fast, keep you in the loop, and don't go live until you're 100% happy." },
  { q: "Do I need to provide content and images?", a: "We can work with what you have. If you need copywriting or images, that's part of our brand support." },
  { q: "Will my website be mobile-friendly?", a: "Yes. Every site is built mobile-first and works on phone, tablet, and desktop." },
  { q: "Do you work with businesses outside of Raleigh?", a: "Yes. We're based in Raleigh-Durham but work with clients across NC and beyond — everything is handled remotely." },
  { q: "What if I already have a website but it needs a refresh?", a: "That's our specialty. We audit your current site, find what's broken, and rebuild it for speed, SEO, and conversions." },
  { q: "Do you offer ongoing maintenance after the site launches?", a: "Yes. Monthly retainer plans cover updates, security patches, performance monitoring, and priority support." },
];

const FAQSection = () => {
  const isMobile = useIsMobile();

  return (
    <section
      id="faq"
      className="lg:sticky top-0 min-h-0 lg:min-h-[100dvh] flex items-center bg-section-warm overflow-hidden relative"
      style={{ zIndex: 9 }}
      data-dark-section
    >
      <SectionGlow placement="bottom-right" />
      <div className="container mx-auto py-16 md:py-20 lg:py-0">
        <div className="grid lg:grid-cols-[1fr_1.5fr] gap-10 md:gap-20 items-start">
          <motion.div
            initial={{ opacity: 0, y: isMobile ? 0 : 12 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.1 }}
            transition={{ duration: duration.smooth, ease: ease.smooth }}
            className="lg:sticky lg:top-1/3"
          >
            <p className="text-xs font-semibold uppercase tracking-[0.25em] text-sage/90 mb-3 md:text-sm">FAQ</p>
            <h2 className="font-heading text-3xl sm:text-4xl md:text-5xl text-cream mb-4 font-bold leading-[1.1]">
              Common Questions,{" "}
              <span className="text-accent-sweep">Clear</span> Answers.
            </h2>
            <p className="text-cream/60 leading-relaxed md:text-lg">
              Everything you need to know before getting started.
            </p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: isMobile ? 0 : 12 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.1 }}
            transition={{ duration: duration.smooth, delay: 0.1, ease: ease.smooth }}
          >
            <Accordion type="single" collapsible className="space-y-2">
              {faqs.map((faq, i) => (
                <AccordionItem
                  key={i}
                  value={`faq-${i}`}
                  className="border border-cream/10 rounded-lg px-5 md:px-6 data-[state=open]:bg-cream/5 transition-colors duration-200"
                >
                  <AccordionTrigger className="text-sm md:text-base font-semibold text-cream hover:no-underline py-4 md:py-5">
                    {faq.q}
                  </AccordionTrigger>
                  <AccordionContent className="text-sm text-cream/60 leading-relaxed pb-4 md:pb-5">
                    {faq.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
